import { FoodState } from "../types/state";
import { RootState } from "../../applicationStore";
import { createSelector } from "@reduxjs/toolkit";
import { TalesFood } from "../../../utils/types/TalesFood";
import { LOADING } from "../../../types";

export const getFoodState = (state: RootState): FoodState => state.food;

export const getFoodData = createSelector(
  getFoodState,
  (foodState): TalesFood[] | null => foodState?.data,
);

export const getFoodError = createSelector(
  getFoodState,
  (foodState): string | null => foodState?.error,
);

export const isFoodLoading = createSelector(
  getFoodState,
  (foodState): boolean => foodState?.loading === LOADING.PENDING ?? false,
);
